import React, {Component} from 'react';
import Menu from "../Menu";
import PageHeader from "../PageHeader";
import GlobalVariable from "../../GlobalVariable";
import api from "../../api";
import './ScheduleStaffs.scss';


export class ScheduleStaffs extends Component <any, any> {
    constructor(props: any) {
        super(props);window.scrollTo(0, 0);
        this.state = {
            showBlock: false,
            showBlockMonth: false,
            activeAddress: 'Загружаем адрес',
            activeMonth: 'Загружаем месяц',
            activeAddressId: null,
            activeMonthApi: null,
            dayMonth: [],

            staffSchedule: [],
            monthArrayName: [],
            timePeriod: [{id: 1, from: '10:00', to: '20:00', onlineRecord: true}],
            AddressArray: [],
            activeDay: [],
            isOpenChooseTime: false,
            SettingScheduleYourself: false,
            SettingScheduleAll: false,
            scheduleNotice: '',
        };
        this.changeActiveMonth = this.changeActiveMonth.bind(this);
    }

    getInfo(activeMonthApi = null, activeAddressId = null) {
        let urlAPI = GlobalVariable.host() + '/widget/staff/date-schedule/' + activeMonthApi + '/' + activeAddressId;
        const data = {};
        api({
            url: urlAPI,
            headers: {'Content-Type': 'application/json'},
            method: "GET",
            data: data,
            withCredentials: true,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status
                const addressArray = result.data.CompanyUserEnable || [];
                const activeCompany = addressArray.find((item) => Number(item.id) === Number(activeAddressId)) || addressArray[0] || {};
                this.setState({
                    staffSchedule: result.data.staffSchedule,
                    dayMonth: result.data.dayMonth,
                    AddressArray: addressArray,
                    activeAddress: activeCompany.address || 'Салон не выбран',
                    activeAddressId: activeCompany.id || activeAddressId,
                    monthArrayName: result.data.monthArrayName,
                    activeMonthApi: result.data.activeMonth.apiDate,
                    activeMonth: result.data.activeMonth.alias,
                    SettingScheduleAll: result.data.SettingScheduleAll,
                    SettingScheduleYourself: result.data.SettingScheduleYourself,

                    isLoad: true,
                    auth: true
                })
                console.log(result.data)
            }).catch(error => {
            if (Number(error.code) === 401) {
                window.location.href = '/start';
            }

            this.setState({
                auth: false,
                isLoad: true,
            })
            // window.location.href = '/' ;
        })
    }

    componentDidMount() {
        this.getInfo()
    }

    changeActiveAddress(address, id) {
        this.setState({
            'activeAddress': address,
            'activeAddressId': id,
            'showBlock': false,
        })
        this.getInfo(this.state.activeMonthApi, id)
    }

    changeActiveMonth(month) {
        this.setState({
            'activeMonth': month.alias,
            'activeMonthApi': month.apiDate,
            'showBlockMonth': false,
        })
        console.log(month)
        this.getInfo(month.apiDate, this.state.activeAddressId)
    }

    showBlock() {
        if (this.state.showBlock) {
            return (
                <div className='schedule-dropdown'>
                    {
                        this.state.AddressArray.map((itemMonth) => (
                            <button
                                key={itemMonth.id}
                                type='button'
                                className={this.state.activeAddressId === itemMonth.id ? 'is-active' : ''}
                                onClick={() => this.changeActiveAddress(itemMonth.address, itemMonth.id)}
                            >
                                {itemMonth.address}
                            </button>
                        ))
                    }

                </div>
            )
        }
    }

    showBlockMonth() {
        if (this.state.showBlockMonth) {

            return (
                <div className='schedule-dropdown'>
                    {

                        this.state.monthArrayName.map((itemMonth) => (
                            <button
                                key={itemMonth.apiDate}
                                type='button'
                                className={this.state.activeMonthApi === itemMonth.apiDate ? 'is-active' : ''}
                                onClick={() => this.changeActiveMonth(itemMonth)}
                            >
                                {itemMonth.alias}
                            </button>
                        ))
                    }

                </div>
            )
        }
    }

    searchDayActive(newArray, array, arr = true) {
        let status = false;
        let index = null;
        newArray.forEach(function (item, i, newArray) {

            if (JSON.stringify(item) === JSON.stringify(array)) {
                status = true;
                index = i;
                return {status: status, index: index}
            }
        });

        return {status: status, index: index}
    }

    canEditSchedule() {
        return Boolean(this.state.SettingScheduleAll || this.state.SettingScheduleYourself);
    }

    activeDay(array) {
        if (!this.canEditSchedule()) {
            this.setState({scheduleNotice: 'Нет прав на изменение графика'});
            return;
        }

        const newArray = [...this.state.activeDay];
        const status = this.searchDayActive(newArray, array, true);

        if (!status?.status) {
            newArray.push(array);
            this.setState({
                activeDay: newArray,
                scheduleNotice: '',
            });
            return;
        }

        const index = Number((status as any).index);
        if (!Number.isNaN(index)) {
            newArray.splice(index, 1);
            this.setState({
                activeDay: newArray,
                scheduleNotice: '',
            });
        }
    }

    changeTimePeriodOnlineRecord(id, onlineRecord) {
        console.log([id, onlineRecord])

        let newArr = this.state.timePeriod;
        const nextStatus = !this.state.timePeriod[id].onlineRecord;
        let newArr2 = {
            id: id,
            from: this.state.timePeriod[id].from,
            to: this.state.timePeriod[id].to,
            onlineRecord: nextStatus
        }
        newArr.splice(id, 1, newArr2);
        console.log(newArr)
        this.setState({
            timePeriod: newArr
        })
    }

    changeTimePeriodOnlineTo(id, to) {


        let newArr = this.state.timePeriod;

        let newArr2 = {
            id: id,
            from: this.state.timePeriod[id].from,
            to: to.target.value,
            onlineRecord: this.state.timePeriod[id].onlineRecord
        }
        newArr.splice(id, 1, newArr2);
        console.log(newArr)
        this.setState({
            timePeriod: newArr
        })
    }

    changeTimePeriodOnlineFrom(id, from) {


        let newArr = this.state.timePeriod;
        let newArr2 = {
            id: id,
            from: from.target.value,
            to: this.state.timePeriod[id].to,
            onlineRecord: this.state.timePeriod[id].onlineRecord
        }
        newArr.splice(id, 1, newArr2);
        console.log(newArr)
        this.setState({
            timePeriod: newArr
        })
    }

    addSlot() {
        let newArr = this.state.timePeriod;
        newArr.push({id: 1, from: '10:00', to: '20:00', onlineRecord: true})
        this.setState({
            timePeriod: newArr
        })
    }

    deleteSlot(id) {
        let newArr = this.state.timePeriod;
        newArr.splice(id, 1);

        this.setState({
            timePeriod: newArr
        })
    }

    getActiveAddressArray() {
        const selected = (this.state.AddressArray || []).find((item) => Number(item.id) === Number(this.state.activeAddressId));
        return selected ? [selected] : this.state.AddressArray;
    }

    sendScheduleStaffs(clean = false) {
        let urlAPI = GlobalVariable.host() + '/widget/staff/date-schedule-add';
        const data = {
            month: this.state.activeMonthApi,
            arrayStaffAndDate: this.state.activeDay,
            timePeriod: this.state.timePeriod,
            addressArray:this.getActiveAddressArray(),
            clean:clean,
        };
        api({
            url: urlAPI,
            headers: {'Content-Type': 'application/json'},
            method: "POST",
            data: data,
            withCredentials: true,
            // receive two    parameter endpoint url ,form data
        })
            .then(result => { // then print response status
                this.getInfo()
                this.setState({
                    activeDay: [],
                    isOpenChooseTime: false,
                    isLoad: true,
                    auth: true
                })
                console.log(result.data)
            }).catch(error => {
            if (Number(error.code) === 401) {
                window.location.href = '/start';
            }

            this.setState({
                auth: false,
                isLoad: true,
            })
            // window.location.href = '/' ;
        })
    }

    toggleChooseTime() {
        return (
            <div className='schedule-time-overlay' onClick={() => this.setState({isOpenChooseTime: false})}>
                <div className='choose-time' onClick={(event) => event.stopPropagation()}>
                    <div className='schedule-sheet-handle'></div>
                    <div className='schedule-sheet-head'>
                        <div>
                            <h2>Изменить смены</h2>
                            <p>{this.state.activeDay.length} выбранных дней</p>
                        </div>
                        <button type='button' onClick={() => this.setState({isOpenChooseTime: false})}>×</button>
                    </div>

                    <div className='schedule-time-head'>
                        <span>Удалить</span>
                        <span>Смена с</span>
                        <span>Смена до</span>
                        <span>Онлайн</span>
                    </div>

                    {this.state.timePeriod.map((item, k) => (
                        <div className='time-row' key={k}>
                            <button type='button' onClick={() => this.deleteSlot(k)} className='schedule-delete-slot'>
                                <img src='/img/trash3.svg' alt=''/>
                            </button>
                            <input onChange={(e) => this.changeTimePeriodOnlineFrom(k, e)}
                                   value={item.from} type='time' placeholder='xx:xx'/>
                            <input onChange={(e) => this.changeTimePeriodOnlineTo(k, e)}
                                   value={item.to} type='time' placeholder='xx:xx'/>
                            <label className='schedule-online-toggle'>
                                <input onChange={() => this.changeTimePeriodOnlineRecord(k, item.onlineRecord)}
                                       type='checkbox' checked={item.onlineRecord} placeholder='xx:xx'/>
                                <span></span>
                            </label>
                        </div>
                    ))}

                    <button type='button' onClick={() => this.addSlot()} className='schedule-add-slot'>
                        <span>+</span>
                        Добавить промежуток
                    </button>

                    <div className='schedule-sheet-actions'>
                        <button type='button' className='schedule-secondary-action'
                                onClick={() => this.setState({isOpenChooseTime: false})}>Отмена</button>
                        <button type='button' onClick={() => this.sendScheduleStaffs()} className='schedule-primary-action'>Сохранить</button>
                        <button type='button' className='schedule-danger-action' onClick={() => this.sendScheduleStaffs(true)}>Пометить нерабочими</button>
                    </div>
                </div>
            </div>
        )

    }

    workingCellsCount() {
        return (this.state.staffSchedule || []).reduce((count, staff) => {
            return count + (staff.day || []).filter((day) => Array.isArray(day) && day.length > 0).length;
        }, 0);
    }

    renderDaySlots(day) {
        if (!Array.isArray(day) || day.length === 0) {
            return <span className='schedule-empty-day'>выходной</span>;
        }

        return day.map((item, index) => (
            <span className='schedule-slot-chip' key={`${item.from}-${item.to}-${index}`}>
                {item.from}-{item.to}
                {item.onlineRecord === false ? <em>offline</em> : null}
            </span>
        ));
    }


    render() {
        const selectedCount = this.state.activeDay.length;
        const staffCount = (this.state.staffSchedule || []).length;
        const workDaysCount = this.workingCellsCount();
        const canEdit = this.canEditSchedule();

        return (
            <div className='main schedule schedule-redesign'>
                <div className='content mx-w-content position-relative schedule-content'>
                    <PageHeader
                        pageTitle='График работы'
                        backBtnUrl='/'/>

                    <div className='pt-header'></div>

                    <section className='schedule-hero'>
                        <div>
                            <span className='schedule-eyebrow'>Расписание мастеров</span>
                            <h1>{this.state.activeMonth}</h1>
                            <p>{this.state.activeAddress}</p>
                        </div>
                        <div className='schedule-hero-badge'>{selectedCount}</div>
                    </section>

                    <section className='schedule-controls'>
                        <div className='schedule-select-card'>
                            <button
                                type='button'
                                onClick={() => this.state.showBlock ? this.setState({'showBlock': false}) : this.setState({'showBlock': true})}
                                className='schedule-select-trigger'
                            >
                                <span><img src='/img/location.svg' alt=''/>Салон</span>
                                <strong>{this.state.activeAddress}</strong>
                            </button>
                            {this.showBlock()}
                        </div>

                        <div className='schedule-select-card'>
                            <button
                                type='button'
                                onClick={() => this.state.showBlockMonth ? this.setState({'showBlockMonth': false}) : this.setState({'showBlockMonth': true})}
                                className='schedule-select-trigger'
                            >
                                <span><img src='/img/calendar.png' alt=''/>Месяц</span>
                                <strong>{this.state.activeMonth}</strong>
                            </button>
                            {this.showBlockMonth()}
                        </div>
                    </section>

                    <section className='schedule-summary'>
                        <div><span>Мастера</span><strong>{staffCount}</strong></div>
                        <div><span>Смены</span><strong>{workDaysCount}</strong></div>
                        <div><span>Выбрано</span><strong>{selectedCount}</strong></div>
                    </section>

                    {this.state.scheduleNotice ? (
                        <div className='schedule-notice'>{this.state.scheduleNotice}</div>
                    ) : null}

                    {this.state.AddressArray.length > 0 && selectedCount > 0 ? (
                        <div className='schedule-selection-bar'>
                            <span>{selectedCount} дней выбрано</span>
                            <button type='button' onClick={() => this.setState({isOpenChooseTime: true})}>
                                Изменить
                            </button>
                            <button type='button' className='secondary' onClick={() => this.setState({activeDay: []})}>
                                Снять
                            </button>
                        </div>
                    ) : null}

                    <div className='schedule-board outer'>
                        <div className='schedule-scroll inner'>
                            <table className='schedule-table'>
                                <thead>
                                <tr>
                                    <th scope='col'>Мастер</th>
                                    {this.state.dayMonth.map((item) => (
                                        <td key={item}>{item}</td>
                                    ))}
                                </tr>
                                </thead>
                                <tbody>
                                {this.state.staffSchedule.map((itemStaff) => (
                                    <tr key={itemStaff.staffId}>
                                        <th className='schedule-staff-cell' scope='row'>
                                            <strong>{itemStaff.staffName}</strong>
                                        </th>
                                        {itemStaff.day.map((v, k) => {
                                            const position = [itemStaff.staffId, Number(k) + 1];
                                            const selected = this.searchDayActive(this.state.activeDay, position).status;
                                            const hasShift = Array.isArray(v) && v.length > 0;
                                            return (
                                                <td
                                                    key={`${itemStaff.staffId}-${k}`}
                                                    className={`schedule-day-cell ${selected ? 'is-selected' : ''} ${hasShift ? 'has-shift' : 'is-empty'} ${canEdit ? 'is-editable' : 'is-disabled'}`}
                                                    onClick={() => this.activeDay(position)}
                                                >
                                                    {this.renderDaySlots(v)}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    </div>

                    {this.state.staffSchedule.length === 0 ? (
                        <div className='schedule-empty-state'>Расписание пока не загружено</div>
                    ) : null}

                    {(this.state.isOpenChooseTime === true) && this.toggleChooseTime()}

                </div>
                <Menu></Menu>
            </div>
        )
    }
}

export default ScheduleStaffs;
